import React from 'react';
import card6 from '../../../assets/images/tarotcards/tarot-card-6.jpg'
import { Link } from 'react-router-dom';
import { sendData } from '../../../../analytics/sendData';
import { FormattedMessage } from 'react-intl';

class Card6 extends React.Component{
    state = {
        showOpenCookie: false
    }

    changeCookieStatus = () => {
        this.setState({showOpenCookie: !this.state.showOpenCookie})
    }

    componentDidMount() {
        sendData('', 'love tarot' , 'engaged');
    }
    
    render() {
    return (
        <div>
                <div component="p" style={{margin:'25px',color: '#e0515d', marginTop: '100px',
                                            fontSize: '45px', fontFamily: 'balthazar,serif',
                                            fontWeight: '300', letterSpacing: '.02em', textAlign: 'center'}}>
                    <FormattedMessage id="dailylove.title"
                                defaultMessage="Free Daily Love Tarot Reading"
                                />
                </div>
                <div style={{padding: '40px'}}>
                <h2 style={{fontFamily: 'khand,sans-serif',
                                fontSize: '2rem',
                                fontWeight: '100',
                                letterSpacing: '.02em',
                                textTransform: 'uppercase', textAlign: 'center'
                            }}><FormattedMessage id="t61"
                            defaultMessage="THE SUN:"
                        />
                    </h2>
                        <img src={card6} style={{marginLeft: '9%', float: 'left', padding: '20px'}}/>
                        
                        <p style={{fontSize: '2rem', color: '#fefefe',
                                    fontFamily: 'balthazar,serif', marginLeft: '20%', marginRight: '20%',fontWeight: '400'}}>  
                        <br></br>
                        <FormattedMessage id="t62"
                            defaultMessage="The Sun shines bright and shows that all will be revealed today. You have a clear romantic path and all of the dark days associated with recent disappointments are over. A hidden truth is revealed, and everything negative associated with it goes away once it is brought to light. There is no arrogance linked with growth today. You deserve the all good things that come your way."
                        />
                        <br></br><br></br>
                    </p>
                </div>
                <div style={{display: 'flex', paddingBottom: '50px'}}>
                    <span style={{width: '33%'}}>
                    </span>
                    <span style={{width: '33%'}}>
                    <Link to="/dailyLove">
                        <button style={{lineHeight: '2', letterSpacing: '0.02em'}} className={'btn btn-danger btn-lg'}><strong><FormattedMessage id="pickano"
                                defaultMessage="PICK ANOTHER CARD"
                                /></strong></button>
                    </Link>
                    </span>
                    <span style={{width: '34%'}}>
                    </span>
                </div>        
        </div>
        )
    }
}

export default Card6;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/tarotCards/tarotCard6.js